import { render, staticRenderFns } from "./Game1-5.vue?vue&type=template&id=1464504e&scoped=true&"
import script from "./Game1-5.vue?vue&type=script&lang=js&"
export * from "./Game1-5.vue?vue&type=script&lang=js&"
import style0 from "./Game1-5.vue?vue&type=style&index=0&id=1464504e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1464504e",
  null
  
)

export default component.exports